import {EntityApiService, ApiClientService} from '@dofleini/security';

class ServicesApiService extends EntityApiService {

    getOneService = ({serviceId}, params) => {
      const config = {params};
      if (params?.projections && Array.isArray(params.projections)) {
        config.params = {
          ...params,
          projections: params.projections.join(',')
        };
      }
      return ApiClientService.get(this.getPath(`/${serviceId}`), config);
    };

}

export default new ServicesApiService('/ms-core/api/services');
